import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TableButton } from "@duosoftbg/nacid-components";
import SearchTable from "../base/table/SearchTable";

const headCells = [
  {
    id: "options",
    label: "",
  },
  {
    id: "applicationNumber",
    label: "l.table.head.recordNumber",
  },
  {
    id: "applicationDate",
    label: "l.table.head.date",
  },
  {
    id: "applicantName",
    label: "l.table.head.applicant",
  },
  {
    id: "applicationCountryName",
    label: "l.table.head.applicationCountryName",
  },
  {
    id: "recognizedProfessionName",
    label: "l.table.head.recognizedProfessionName",
  },
  {
    id: "decisionNumber",
    label: "l.table.head.decisionNumber",
  },
  {
    id: "applicationStatus",
    label: "l.table.head.status",
  },
];

const RSearchProfessionalQualificationListTable = ({
  total,
  records,
  blockTable,
  onPageOrOrderChange,
  group,
  viewURL,
}) => {
  return (
    <SearchTable
      group={group}
      headCells={headCells}
      total={total}
      blockTable={blockTable}
      onPageOrOrderChange={onPageOrOrderChange}
    >
      <TableBody>
        {records.map((row) => {
          return (
            <TableRow hover key={row.id}>
              <TableCell style={{ textAlign: "center" }}>
                <TableButton to={`${viewURL}${row.id}`} />
              </TableCell>
              <TableCell>{row.applicationNumber}</TableCell>
              <TableCell>{row.applicationDate}</TableCell>
              <TableCell>{row.applicantName}</TableCell>
              <TableCell>{row.applicationCountryName}</TableCell>
              <TableCell>{row.recognizedProfessionName}</TableCell>
              <TableCell>{row.decisionNumber}</TableCell>
              <TableCell>{row.applicationStatus && row.applicationStatus.name}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </SearchTable>
  );
};

export default RSearchProfessionalQualificationListTable;
